import { render, staticRenderFns } from "./ClarityFooter.vue?vue&type=template&id=704d1022&"
import script from "./ClarityFooter.vue?vue&type=script&lang=ts&"
export * from "./ClarityFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports